import { useRef, type FC } from 'react';
import SearchHeroLayout from 'src/common/components/Search/SearchHero/SearchHeroLayout';
import SearchHeroModalProvider from 'src/common/components/Search/SearchHero/SearchHeroModalProvider';
import type { SearchHeroTheme, SearchHeroVariant } from 'src/common/components/Search/types';
import { type SearchRefs } from 'src/common/components/Search/SearchInputProvider';
import { SearchComboboxProvider } from 'src/common/components/Search/SearchComboboxProvider';

export type SearchHeroProps = {
  variant?: SearchHeroVariant;
  theme?: SearchHeroTheme;
};

const SearchHero: FC<SearchHeroProps> = ({ variant = 'navigation', theme = 'white' }) => {
  const refs: SearchRefs = {
    inputs: useRef<HTMLDivElement>(null),
    where: useRef<HTMLInputElement>(null),
    when: useRef<HTMLInputElement>(null),
    who: useRef<HTMLInputElement>(null),
    button: useRef<HTMLButtonElement>(null),
    capacityNumber: useRef<HTMLInputElement>(null),
  };

  return (
    <SearchHeroModalProvider>
      <SearchComboboxProvider id={variant} refs={refs}>
        <SearchHeroLayout refs={refs} variant={variant} theme={theme} />
      </SearchComboboxProvider>
    </SearchHeroModalProvider>
  );
};

export default SearchHero;
